export default process.env.VUE_APP_BASE_URL;

export const prize = process.env.VUE_APP_BASE_URL_PRIZE;
export const MANAGE = process.env.VUE_APP_BASE_URL_MANAGE;
